import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RegenerateTenantBody, TenantUpdateDto, TenantDto, RegenerateTenantDto } from 'app/models/api/tenant';
import { API_ENDPOINT } from './utils.service';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private readonly TENANT_API: string = `${API_ENDPOINT}/tenant-managers`;
  private http: HttpClient = inject(HttpClient);

  getTenant(): Observable<TenantDto> {
    return this.http.get<TenantDto>(`${this.TENANT_API}`);
  }

  regenerateSignUpKey(body: RegenerateTenantBody): Observable<RegenerateTenantDto> {
    return this.http.get<RegenerateTenantDto>(`${this.TENANT_API}/regenerate/${body.id}/${body.oldSignUpKey}`);
  }

  saveTenant(body: TenantUpdateDto): Observable<TenantDto> {
    return this.http.post<TenantDto>(`${this.TENANT_API}/update`, body);
  }
}
